import { render, staticRenderFns } from "./TeamMenuGroup.vue?vue&type=template&id=7b52194e&scoped=true"
import script from "./TeamMenuGroup.vue?vue&type=script&lang=js"
export * from "./TeamMenuGroup.vue?vue&type=script&lang=js"
import style0 from "@/styles/_left_menu.scss?vue&type=style&index=0&id=7b52194e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52194e",
  null
  
)

export default component.exports